<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Projects"
};
</script>

<style scoped>
</style>
